// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y0eG","tabsBox":"styles_tabsBox__1a3Vr","createButton":"styles_createButton__3WuNf"};